import React, { useContext } from 'react'
import getCatalogPath from '@App/helpers/work-entities/utils/get-catalog-path'
import WorkItemData from '@Components/WorkItemV2/work-item-data'
import ExtendedWorkItem from '@Components/WorkItemV2/ExtendedWorkItem'
import BulkActionCheckbox from '@Components/WorkItemV2/BulkActionCheckbox'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import ShareDisplay from '@Components/WorkItemV2/ShareDisplay'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import Navigation from '@App/navigation'
import './index.scss'
import { observer } from 'mobx-react'
import { getCatalogWorkFields } from '@Components/WorkItemV2/Catalog/CatalogExtendedWorkItem/get-catalog-work-fields'

const CatalogExtendedWorkItem = (props: WorkItemData) => {
    const { rightsholderStore, songwriterStore, catalogSearchBulkActionStore } = useContext<RootStore>(StoresContext)
    const { work, yourShares, handleOnClick } = props

    const limitReached =
        catalogSearchBulkActionStore.idsSelectedForBulkAction.size > 100 &&
        !catalogSearchBulkActionStore.idsSelectedForBulkAction.has(work.id as number)

    const totalSharesTooltipText =
        work.totalKnownShares < 100
            ? 'Part of these shares is unknown, so the total is less than 100%.'
            : 'This reflects total claimed shares on this work by all parties.'

    const catalogPath =
        props.displayType === 'public'
            ? Navigation.viewWork.root(work.id || 0)
            : props.displayType === 'songwriter'
              ? Navigation.songwriter.viewSearchedWork(songwriterStore.currentSongwriterId, work.id || 0)
              : getCatalogPath(work.isComplete, rightsholderStore.currentRightsholderId, work.id || 0)

    const bulkActionDisabled = React.useMemo(() => {
        if (limitReached) {
            return { value: true, message: 'You can only select up to 100 works at a time.' }
        }
        return { value: false, message: '' }
    }, [limitReached])

    const isBulkActionStarted = catalogSearchBulkActionStore.activeBulkAction !== null

    return (
        <div className="catalog-extended-work-item-wrapper">
            <ExtendedWorkItem
                work={work}
                fields={getCatalogWorkFields(work)}
                catalogPath={catalogPath}
                handleOnClick={handleOnClick}
                showOverclaimTooltip
                isBulkActionDisabled={bulkActionDisabled.value}
                isBulkActionStarted={isBulkActionStarted}
                selectionControl={
                    isBulkActionStarted && (
                        <BulkActionCheckbox
                            id={work.id?.toString() || ''}
                            checked={!!work.id && catalogSearchBulkActionStore.idsSelectedForBulkAction.has(work.id)}
                            onToggle={() => catalogSearchBulkActionStore.toggleSelectionForBulkAction(work.id)}
                            disabled={bulkActionDisabled.value}
                            disabledMessage={bulkActionDisabled.message}
                        />
                    )
                }
            >
                {props.yourShares && (
                    <ShareDisplay
                        share={yourShares}
                        tooltip={
                            <CustomToolTip
                                title="Your Shares:"
                                info="This represents the total shares you have claimed on this work."
                            />
                        }
                    />
                )}

                <ShareDisplay
                    share={work.totalKnownShares}
                    highlight
                    tooltip={<CustomToolTip title="Total Known Shares:" info={totalSharesTooltipText} />}
                />
            </ExtendedWorkItem>
        </div>
    )
}

export default observer(CatalogExtendedWorkItem)
